export class TeamFileLinkDto {
  public teamId: number = 0;
  public fileId: number = 0;
  constructor(teamId: number, fileId: number) {
    this.teamId = teamId;
    this.fileId = fileId;
  }
}